<!--ELEARNING STATIC PAGE CONTENT-->
<ng-container *ngIf="elearningStaticPage">
  <!--TABLE OF CONTENTS EXPAND COLLAPSE-->
  <div *ngIf="elearningStaticPage && elearningStaticPage.length > 0" class="table-of-contents">
    <div class="large-text bold padding-bottom-small">
      <a
        class="gen-neutral-black-link-no-text-decoration flexbox"
        href="javascript:void(0);"
        (click)="onToggleNavigation()">
        Table of Contents
        <i
          class="icon small red margin-left-auto"
          [ngClass]="showNav ? 'arrow-down' : 'arrow-up'"></i>
      </a>
    </div>
    <!--TABLE OF CONTENTS LIST-->
    <div class="margin-top-small" [style.display]="showNav ? 'none' : 'block'">
      <ul class="padding-left-small padding-bottom-small">
        <li
          class="list-style-disc"
          *ngFor="
            let elearningStaticPageResponse of elearningStaticPage;
            let i = index;
            trackBy: trackByElearningStaticPageId
          ">
          <a
            class="gen-neutral-orange-link-underline"
            href="{{ currentSlugPage }}#{{ elearningStaticPageResponse.acf.hash_value }}"
            [attr.fragment]="elearningStaticPageResponse.acf.hash_value">
            {{ elearningStaticPageResponse.title | decodeEntities }}
          </a>
        </li>
      </ul>
    </div>
    <!--END TABLE OF CONTENTS LIST-->
  </div>
  <!--END TABLE OF CONTENTS EXPAND COLLAPSE-->

  <!--ELEARNING STATIC PAGE SECTION-->
  <div
    class="elearning-static-page padding-bottom-large"
    *ngFor="
      let elearningStaticPageResponse of elearningStaticPage;
      let i = index;
      trackBy: trackByElearningStaticPageId
    ">
    <ng-container *ngIf="elearningStaticPageResponse.acf">
      <!--SECTION TITLE-->
      <h2 class="margin-bottom-large margin-top-large red text-align-left bold">
        {{ elearningStaticPageResponse.acf.section_title | decodeEntities }}
      </h2>
      <!--END SECTION TITLE-->
      <div id="{{ elearningStaticPageResponse.acf.hash_value }}" class="scroll-height">
        <h3 class="margin-bottom-small bold">
          {{ elearningStaticPageResponse.title | decodeEntities }}
        </h3>
      </div>
      <!--DATE ADDED-->
      <div class="margin-bottom-large brand" *ngIf="elearningStaticPageResponse.acf?.added">
        <span *ngIf="elearningStaticPageResponse.acf.new_course"><strong>NEW !</strong></span>
        <label><strong>Added: </strong></label>
        <span>
          <strong>{{ elearningStaticPageResponse?.acf?.added }}</strong>
        </span>
      </div>
      <!--END DATE ADDED-->
      <!--ELEARNING STATIC RESPONSE CONTENT-->
      <div class="margin-bottom-large">
        <label><strong>Description: </strong></label>
        <div class="htmlresponse" [innerHTML]="elearningStaticPageResponse.content"></div>
      </div>
      <!--END ELEARNING STATIC RESPONSE CONTENT-->
      <!--DURATION-->
      <div class="margin-bottom-small" *ngIf="elearningStaticPageResponse.acf?.duration">
        <label><strong>Duration: </strong></label>
        <span>{{ elearningStaticPageResponse?.acf?.duration }}</span>
      </div>
      <!--END DURATION-->
      <!--AUDIENCE-->
      <div class="margin-bottom-large" *ngIf="elearningStaticPageResponse.acf?.audience">
        <label><strong>Audience: </strong></label>
        <span>{{ elearningStaticPageResponse?.acf?.audience }}</span>
      </div>
      <!--END AUDIENCE-->
      <!--START COURSE BUTTON-->
      <a
        [attr.data-event]="elearningStaticPageResponse.title"
        (click)="sendGoogleAnalytics('cms', 'click', elearningStaticPageResponse.title)"
        class="btn btn-primary"
        href="{{ elearningStaticPageResponse.acf.start_course_url }}"
        target="_blank"
        rel="noopener noreferrer nofollow">
        Start Course
      </a>
      <!--END START COURSE BUTTON-->
    </ng-container>
  </div>
  <!--END ELEARNING STATIC PAGE SECTION-->
</ng-container>
<!--ELEARNING STATIC PAGE CONTENT-->
